// extracted by mini-css-extract-plugin
export var chip = "_3v-9";
export var chipLabel = "_3v-a";
export var close = "_3v-7";
export var closeIcon = "_3v-8";
export var error = "_3v-6";
export var infoTooltip = "_3v-2";
export var innerContainer = "_3v-1";
export var input = "_3v-b";
export var medium = "_3v-5";
export var outerContainer = "_3v-0";
export var small = "_3v-4";
export var xSmall = "_3v-3";